import { IonContent, IonPage } from '@ionic/react'
import React, { PropsWithChildren, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ResourceType } from '../../@types/i18n'
import { AppBarOptions } from '../../components/layout/AppBar'
import { AppContext } from '../../contexts/AppContext'
import NativePageLayout from './components/NativePageLayout'
import WepPageLayout from './components/WebPageLayout'

export interface PageWrapperProps {
	page: keyof ResourceType['pages'] | 'overview' | 'contact'
	appBarOptions?: Partial<AppBarOptions>
}

const PageWrapper = ({
	children,
	page,
	appBarOptions,
}: PropsWithChildren<PageWrapperProps>) => {
	const { t } = useTranslation('pages')
	const { isMobileView } = useContext(AppContext)

	return (
		<IonPage>
			<IonContent>
				<div className='min-h-full bg-background-100-light dark:bg-background-100-dark flex flex-col'>
					{isMobileView ? (
						<NativePageLayout page={page} appBarOptions={appBarOptions} t={t}>
							{children}
						</NativePageLayout>
					) : (
						<WepPageLayout page={page} appBarOptions={appBarOptions} t={t}>
							{children}
						</WepPageLayout>
					)}
				</div>
			</IonContent>
		</IonPage>
	)
}

export default PageWrapper
